module.exports = __webpack_public_path__ + "img/stick_hebergements_hebergement_insolite.578c6b21.svg";